export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empfänger: "])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer nicht gefunden"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kontakte"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mehr erfahren"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer auswählen"])}
}